import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { CreateBatchDialogComponent } from '../create-batch-dialog/create-batch-dialog.component'; // import your create batch dialog
import { StudentManagementService } from '@edtech-ui/core/services/admin-panel/studentManagement.service';
import { ToastrService } from 'ngx-toastr';
import { InviteStudentRequest } from '@edtech-ui/core/models/admin-panel/invite-student.model';
import { TeacherManagementService } from '@edtech-ui/core/services/admin-panel/teacherManagement.service';
import { BatchManagementService } from '@edtech-ui/core/services/batch-management/batch-management.service';
import { finalize, map, Subject, takeUntil } from 'rxjs';
import { NavigationStart, Route, Router } from '@angular/router';

@Component({
  selector: 'app-student-invite-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './student-invite-dialog.component.html',
  styleUrls: ['./student-invite-dialog.component.scss']
})
export class StudentInviteDialogComponent {
  private destroy$ = new Subject<void>();
  fullName = '';
  email = '';

  selectedBatchId: number | null = null;
  selectedDepartmentId: number | string = '';
  selectedDepartmentName = '';
  batches: { id: number; name: string }[] = [];
  departments: { id: number | string; name: string }[] = [];
  isLoading = false;
  searchDepartment = '';
  filteredDepartments: { id: number | string; name: string }[] = [];

  constructor(
    private dialogRef: MatDialogRef<StudentInviteDialogComponent>,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private studentService: StudentManagementService,
    private teacherService: TeacherManagementService,
    private batchService: BatchManagementService,
    private router : Router,

  ) { }

  ngOnInit() {
    this.loadBatches();
    this.loadDepartments();
       this.router.events
    .pipe(takeUntil(this.destroy$))
    .subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialogRef.close();
      }
    });
  
  }

  close() {
    this.dialogRef.close();
  }

  loadBatches() {
    this.batchService.getAllTenantsBatches()
      .pipe(
        map(res => res.Data?.batches?.map((b: any) => ({
          id: b.id,
          name: b.name
        })) || [])
      )
      .subscribe({
        next: (batches) => this.batches = batches,
        error: () => this.toastr.error("Failed to load batches.")
      });
  }


  loadDepartments() {
    this.teacherService.getDepartments().subscribe({
      next: (res) => {
        if (res.Success && res.Data) {
          this.departments = res.Data;
          this.filteredDepartments = [...this.departments];
        }
      },
      error: () => {
        this.toastr.error("Failed to load departments.");
      }
    });
  }

  onSelectDepartment(id: number | string) {
    const dept = this.departments.find(x => x.id === id);
    this.selectedDepartmentName = dept?.name || '';
    this.selectedDepartmentId = id;
  }

  sendInvite() {

  const name = this.fullName.trim();
  const email = this.email.trim();

  if (!name || !email || !this.selectedBatchId || !this.selectedDepartmentId) {
    this.toastr.warning('Please fill all fields.');
    return;
  }

  const nameRegex = /^[A-Za-z][A-Za-z\s'.-]{1,}$/;
  if (!nameRegex.test(name)) {
    this.toastr.warning('Please enter a valid full name (letters and spaces only).');
    return;
  }

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!emailRegex.test(email)) {
    this.toastr.warning('Please enter a valid email');
    return;
  }
    this.isLoading = true;
    const payload: InviteStudentRequest = {
      batch_id: this.selectedBatchId,
      department_id: String(this.selectedDepartmentId),
      department_name: this.selectedDepartmentName,
      email: this.email,
      full_name: this.fullName
    };

    this.studentService.inviteStudent(payload)
    .pipe(
      finalize(() => this.isLoading = false),
      takeUntil(this.destroy$)   
    )
    .subscribe({
      next: (res) => {
        if (res.Success) {
          this.toastr.success('Invitation sent successfully!');
          this.dialogRef.close(true);
        } else {
          this.toastr.error(res.Message);
        }
      },
      error: (err) => {
        this.toastr.error(err.error?.Message || 'Something went wrong.');
      }
    });
  }

  filterDepartments() {
    const text = this.searchDepartment.toLowerCase();
    this.filteredDepartments = this.departments.filter(d =>
      d.name.toLowerCase().includes(text)
    );
  }

  onOpenDepartment(opened: boolean) {
    if (!opened) {
      this.searchDepartment = '';
      this.filteredDepartments = [...this.departments];
    }
  }

  openCreateBatchDialog() {
    this.dialog.open(CreateBatchDialogComponent, {
      width: '500px'
    });
  }
  ngOnDestroy() {
  this.destroy$.next();
  this.destroy$.complete();
}
}
